const axios = require("axios");
const config = require("../config");
/* function timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
} */
/* Structures List */
async function getStructuresList() {
  const responseData = await axios.get(config.API_ENDPOINT + "structures");
  return responseData.data;
}

/* Structure Details */
async function getStructureDetails(structID) {
  const responseData = await axios.get(config.API_ENDPOINT + "structures", {
    params: {
      id: structID,
    },
  });
  return responseData.data;
}

/* Delete Vibration by ID */
async function deleteVibrationEvent(eventID) {
  const responseData = await axios.delete(config.API_ENDPOINT + "sensor_data/vibrations/" + eventID);
  return responseData.data;
}

/* Delete Acceleration by ID */
async function deleteAccelerationEvent(eventID) {
  const responseData = await axios.delete(config.API_ENDPOINT + "sensor_data/accelerations/" + eventID);
  return responseData.data;
}

/* Temperatures List */
async function getTemperaturesList(eui, firstDate, lastDate) {
  const responseData = await axios.get(
    config.API_ENDPOINT + "sensor_data/temperatures",
    {
      params: {
        eui: eui,
        firstDate: new Date(firstDate),
        lastDate: new Date(lastDate),
      },
    }
  );
  return responseData.data;
}

/* Displacements List */
async function getDisplacementsList(eui, firstDate, lastDate) {
  const responseData = await axios.get(
    config.API_ENDPOINT + "sensor_data/vibrations",
    {
      params: {
        eui: eui,
        firstDate: new Date(firstDate),
        lastDate: new Date(lastDate),
      },
    }
  );
  return responseData.data;
}

/* Displacements Details */
async function getDisplacementsDetails(id) {
  const responseData = await axios.get(
    config.API_ENDPOINT + "sensor_data/vibrations",
    {
      params: {
        id: id,
      },
    }
  );
  return responseData.data;
}

/* Acceleration Details */
async function getAccelerationDetails(id) {
  const responseData = await axios.get(
    config.API_ENDPOINT + "sensor_data/accelerations",
    {
      params: {
        id: id,
      },
    }
  );
  return responseData.data;
}

/* Tilts List */
async function getTiltsList(eui, firstDate, lastDate, absoluteMode, beamFormat) {
  const responseData = await axios.get(
    config.API_ENDPOINT + "sensor_data/tilts",
    {
      params: {
        eui: eui,
        firstDate: new Date(firstDate),
        lastDate: new Date(lastDate),
        absoluteMode: absoluteMode,
        beamFormat: beamFormat
      },
    }
  );
  return responseData.data;
}

/* Cracks List */
async function getCracksList(eui, firstDate, lastDate) {
  const responseData = await axios.get(
    config.API_ENDPOINT + "sensor_data/cracks",
    {
      params: {
        eui: eui,
        firstDate: new Date(firstDate),
        lastDate: new Date(lastDate),
      },
    }
  );
  //await timeout(8000);

  return responseData.data;
}

/* Analog Node Readings List */
async function getAnalogReadings(eui, firstDate, lastDate) {
  const responseData = await axios.get(
    config.API_ENDPOINT + "sensor_data/analog-node",
    {
      params: {
        eui: eui,
        firstDate: new Date(firstDate),
        lastDate: new Date(lastDate),
      },
    }
  );
  return responseData.data;
}

/* Accelerations List */
async function getAccelerationsList(eui, firstDate, lastDate) {
  const responseData = await axios.get(
    config.API_ENDPOINT + "sensor_data/accelerations",
    {
      params: {
        eui: eui,
        firstDate: new Date(firstDate),
        lastDate: new Date(lastDate),
      },
    }
  );
  return responseData.data;
}

/* Temperatures List */
async function getFDDList(structureID, limit, firstDate, lastDate) {
  const responseData = await axios.get(
    config.API_ENDPOINT + "structures/fdd",
    {
      params: {
        structureID: structureID,
        limit: limit,
        firstDate: new Date(firstDate),
        lastDate: new Date(lastDate)
      }
    }
  );
  return responseData.data;
}


/* Tilt Offset */
async function getTiltOffset(eui) {
  const responseData = await axios.get(
    config.API_ENDPOINT + "sensor_data/tilts",
    {
      params: {
        eui: eui,
        first: "true",
      },
    }
  );
  return responseData.data;
}

/* Crack Offset */
async function getCrackOffset(eui) {
  const responseData = await axios.get(
    config.API_ENDPOINT + "sensor_data/cracks",
    {
      params: {
        eui: eui,
        first: "true",
      },
    }
  );
  //await timeout(8000);
  return responseData.data;
}

/* Single Trend */
async function getTrend(eui, firstDate, lastDate) {
  const response = await axios.get(config.API_ENDPOINT + "sensor_data/trend", {
    params: {
      eui: eui,
      firstDate: new Date(firstDate),
      lastDate: new Date(lastDate),
    },
  });
  return response.data;
}

/* Multiple Trend */
async function getMultipleTrends(euis, firstDate, lastDate) {
  const promises = euis.map((eui) => getTrend(eui, firstDate, lastDate));
  return await Promise.all(promises);
}

/* Displacement FFT */
async function getDispFFT(payload) {
  const response = await axios.post(config.DISP_FFT_ENDPOINT, {
    dati: JSON.stringify(payload),
  });
  return response.data;
}

/* Acceleration FFT */
async function getAccFFT(payload) {
  const response = await axios.post(config.ACC_FFT_ENDPOINT, {
    dati: JSON.stringify(payload),
  });
  return response.data;
}

/* DECKPOST POST-PROCESSING */

async function getDeflection(payload) {
  const response = await axios.post(config.DECKPOST_ENDPOINT + "deflection/deflectionFinder", payload);
  return response.data;
}

async function getFreqCluster(firstDate, lastDate, structureID, fddType, groupNumber) {
  const body = {
    fddType: fddType,
    structureID: structureID,
    group: groupNumber,
    startDate: firstDate,
    endDate: lastDate,
    axis: null
  }
  const response = await axios.post(config.DECKPOST_ENDPOINT + "frequencyclustering/clustering", body);
  return response.data;
}

/* Login */
async function login(username, password) {
  const response = await axios.post(config.AUTH_ENDPOINT + "login", {
    username: username,
    password: password,
  });
  return response.data;
}

/* Logout */
async function logout(refresh_token) {
  const response = await axios.delete(config.AUTH_ENDPOINT + "refresh_token", {
    data: { token: refresh_token },
  });
  return response.data;
}

/* Refresh Token */
async function refreshToken(userID, refresh_token) {
  const response = await axios.post(config.AUTH_ENDPOINT + "refresh_token", {
    id: userID,
    refreshToken: refresh_token,
  });
  return response.data;
}

/* Get Sub Users */
async function getSubUsers() {
  const response = await axios.get(config.API_ENDPOINT + "users");
  return response.data;
}

/* Insert a New Sub User */
async function insertNewSubUser(username, password) {
  const response = await axios.post(config.AUTH_ENDPOINT + "users", {
    username: username,
    password: password,
  });
  return response.data;
}

/* Update an exsisting Sub User */
async function updateSubUser(subUserID, username, password) {
  console.log(subUserID, username, password)
  const response = await axios.put(config.AUTH_ENDPOINT + "users",
    {
      username: username,
      password: password,
    },
    { params: { subUserID: subUserID } }
  );
  return response.data;
}

/* Delete an exsisting Sub User */
async function deleteSubUser(subUserID) {
  const response = await axios.delete(config.AUTH_ENDPOINT + "users", {
    params: { subUserID: subUserID },
  });
  return response.data;
}
/* Get Sensor Settings by StructureID */
async function getSensorsSettings(structID) {
  const response = await axios.get(config.API_ENDPOINT + "config/sensors", {
    params: { structID: structID },
  });
  return response.data;
}

/* Get User Settings by StructureID */
async function getUserSettings() {
  const response = await axios.get(config.API_ENDPOINT + "config/user");
  return response.data;
}

/* Save User settings */
async function saveUserSettings(userSettings) {
  const response = await axios.put(
    config.API_ENDPOINT + "config/user",
    userSettings
  );
  return response.data;
}

/* Save Sensor Settings */
async function saveSensorsSettings(sensorSettings) {
  const response = await axios.put(
    config.API_ENDPOINT + "config/sensors",
    sensorSettings
  );
  return response.data;
}
/* Save Sensor Settings */
async function saveSensorsPosition(sensorPosition) {
  const response = await axios.put(
    config.API_ENDPOINT + "config/sensors/position",
    sensorPosition
  );
  return response.data;
}

/* Save Sensor Settings by Admin*/
async function adminSaveSensorsPosition(customerID, sensorPosition) {
  const response = await axios.put(
    config.API_ENDPOINT + "admin/sensors/position",
    sensorPosition,
    {
      params: {
        customerID: customerID,
      }
    }
  );
  return response.data;
}

/* Save Struct Settings */
async function saveStructSettings(structSettings) {
  const response = await axios.put(
    config.API_ENDPOINT + "config/structure",
    structSettings
  );
  return response.data;
}

/* Reset Sensor Base Value */
async function resetOffset(eui) {
  const response = await axios.put(
    config.API_ENDPOINT + "config/sensors/basevalue",
    { eui: eui }
  );
  return response.data;
}

/* ADMIN */
async function getUsers() {
  const response = await axios.get(config.API_ENDPOINT + "admin");
  return response.data;
}

async function getStructures(customerID) {
  const response = await axios.get(config.API_ENDPOINT + "admin/structures", {
    params: { customerID: customerID },
  });
  return response.data;
}

async function insertStructure(customerID, structure) {
  const response = await axios.post(config.API_ENDPOINT + "admin/structures", {
    customerID: customerID,
    structure: structure
  });
  return response.data;
}

async function editStructure(customerID, structureID, structureInfo) {
  const response = await axios.put(
    config.API_ENDPOINT + "admin/structures",
    structureInfo,
    {
      params: {
        customerID: customerID,
        structureID: structureID
      },
    }
  );
  return response.data;
}

async function deleteImageFromStructure(customerID, structureID, imageID) {
  const response = await axios.delete(
    config.API_ENDPOINT + "admin/structures/image",
    {
      params: {
        customerID: customerID,
        structureID: structureID,
        imageID: imageID
      },
    }
  );
  return response.data;
}

async function addImageToStructure(customerID, structureID, imageFile) {
  var bodyFormData = new FormData();
  bodyFormData.append('image', imageFile);
  const response = await axios({
    method: 'post',
    url: config.API_ENDPOINT + "admin/structures/image",
    data: bodyFormData,
    params: {
      customerID: customerID,
      structureID: structureID,
    },
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
}

async function deleteStructure(customerID, structureID) {
  const response = await axios.delete(
    config.API_ENDPOINT + "admin/structures",
    {
      params: {
        customerID: customerID,
        structureID: structureID,
      },
    }
  );
  return response.data;
}

async function deleteUser(customerID) {
  const response = await axios.delete(config.API_ENDPOINT + "admin/", {
    params: {
      customerID: customerID,
    },
  });
  return response.data;
}

async function addUser(user) {
  const response = await axios.post(config.API_ENDPOINT + "admin/", user);
  return response.data;
}

async function editUser(customerID, customerInfo) {
  const response = await axios.put(
    config.API_ENDPOINT + "admin/",
    customerInfo,
    {
      params: {
        customerID: customerID,
      },
    }
  );
  return response.data;
}

async function deleteSensor(structID, customerID, sensorEUI) {
  const response = await axios.delete(config.API_ENDPOINT + "admin/sensors", {
    params: {
      structureID: structID,
      customerID: customerID,
      eui: sensorEUI,
    },
  });
  return response.data;
}

async function resetSensorStats(structID, customerID, sensorEUI) {
  const response = await axios.delete(config.API_ENDPOINT + "admin/sensors/stats", {
    params: {
      structureID: structID,
      customerID: customerID,
      eui: sensorEUI,
    },
  });
  return response.data;
}

async function addSensors(customerID, structureID, sensorArray) {
  const response = await axios.post(config.API_ENDPOINT + "admin/sensors", {
    customerID: customerID,
    structureID: structureID,
    sensors: sensorArray,
  });
  return response.data;
}

async function updateSensor(customerID, eui, sensorInfo) {
  const response = await axios.put(
    config.API_ENDPOINT + "admin/sensors",
    sensorInfo,
    {
      params: {
        customerID: customerID,
        eui: eui,
      },
    }
  );
  return response.data;
}

async function updateFDDGroups(customerID, structureID, type, sensorGroups) {
  const response = await axios.put(
    config.API_ENDPOINT + "admin/sensors/groups",
    sensorGroups,
    {
      params: {
        type: type,
        customerID: customerID,
        structureID: structureID,
      },
    }
  );
  return response.data;
}

// Cancella gli eventi precedenti alla data d'installazione
async function deleteOldEvents(customerID, structID) {
  const response = await axios.delete(config.API_ENDPOINT + "admin/users/" + customerID + "/structures/" + structID);
  return response.data;
}

module.exports = {
  getStructuresList,
  getStructureDetails,
  deleteVibrationEvent,
  deleteAccelerationEvent,
  getTemperaturesList,
  getDisplacementsList,
  getDisplacementsDetails,
  getAccelerationDetails,
  getTiltsList,
  getCracksList,
  getAnalogReadings,
  getAccelerationsList,
  getTiltOffset,
  getCrackOffset,
  getMultipleTrends,
  getDispFFT,
  getAccFFT,
  getDeflection,
  getFreqCluster,
  getFDDList,
  getUserSettings,
  getSensorsSettings,
  saveUserSettings,
  saveSensorsSettings,
  saveSensorsPosition,
  saveStructSettings,
  resetOffset,
  login,
  logout,
  refreshToken,
  getSubUsers,
  insertNewSubUser,
  updateSubUser,
  deleteSubUser,
  /* ADMIN */
  getUsers,
  getStructures,
  insertStructure,
  editStructure,
  deleteStructure,
  deleteImageFromStructure,
  addImageToStructure,
  deleteUser,
  addUser,
  editUser,
  deleteSensor,
  addSensors,
  updateSensor,
  resetSensorStats,
  adminSaveSensorsPosition,
  updateFDDGroups,
  deleteOldEvents
};
